import type { Team } from '@/types/api';
import { cn } from '@/utils/cn';

export const TeamChip = ({
  team,
  reverse = false,
}: {
  team: Team;
  reverse?: boolean;
}) => (
  <div
    className={cn(
      'flex items-center gap-4 text-2xl font-bold uppercase',
      reverse && 'flex-row-reverse',
    )}
  >
    {team.team_image_url ? (
      <img className="size-12" src={team.team_image_url} alt={team.name} />
    ) : (
      <span
        role="img"
        aria-label={team.name}
        className={cn('fi', team.country_code && `fi-${team.country_code}`)}
      />
    )}
    {team.scoreboard_name}
  </div>
);
